var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.formatedErrors)?_c('div',{staticClass:"erros"},_vm._l((_vm.formatedErrors),function(error){return _c('p',{staticClass:"help has-text-centered is-danger"},[_vm._v(_vm._s(error))])}),0):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }